<div class="landing-inversores__card landing-inversores__shadow-card landing-inversores__lead-form">
  <h3 class="landing-inversores__lead-form-title">Reserva tu Asesoría Gratuita 👇</h3>
  <p class="landing-inversores__lead-form-subtitle">
    Sin compromiso. Te enseñamos oportunidades reales y tú decides.
  </p>
  <div [id]="containerId"></div>
</div>
